<template>
  <div>        
    <v-range-slider class="mx-2 my-0" :color="endMissionMode?'secondary':'primary'" hide-details ref="slider"  thumb-label thumb-size="22" :value="currentValue" @change="endMove" @input="onMove"  :min="0" :max="dates.length > 0?dates.length-1:0"  step=1 >
        <template slot="thumb-label" slot-scope="props">
          <span>
            {{ cycles[props.value] }}
          </span>
        </template>        
      </v-range-slider>         
    <v-layout v-show="false" caption mx-1 pa-0 justify-space-between>
      <span>{{dates[0] | formatDate}}</span>
      <span>[{{dates[currentValue[0]] | formatDate}} - {{dates[currentValue[1]] | formatDate}}]</span>
      <span>{{dates[dates.length-1] | formatDate}}</span>    
    </v-layout>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'       
  import { AloMission } from '@/models/alo/AloMission'
  export default {
   name: 'MissionRangeTimeLine',
   props:{
      mission:{
        type: AloMission
      },
      uiid:{
          type: String,
          required: true
      },
      updateOnMove:{
        type:Boolean,
        default:true
      },
      endMissionMode:{
        type:Boolean,    
        default:false
      }            
    },
    data(){
      return {
        currentValue : [0,0]
      }
    },
    mounted(){
      this.checkRange(this.rangeTimelineIndex)
    },
   computed: {
       ...mapGetters([             
         'uistatebyuiid'  
         ]),   
      missionState() {  
        //retourne un MissionUiState        
        return this.uistatebyuiid(this.uiid)
      }, 
      rangeTimelineIndex(){
        return this.missionState.rangeTimelineIndex
      },
      dates() {
        return this.mission.yoArray.map(y => y.yoGpsDatTime)        
      },
      cycles() {
        return this.mission.yoArray.map(y => y.yosCycle)
      },      
    },
    watch:{
      rangeTimelineIndex(range) {
        this.checkRange(range)
      }
    },
    methods: {
      updateDate(val) {
        this.currentValue = val
      },
      changeValue(val) {                
        this.$store.myActions.UI_SELECT_RANGETIMELINE_MISSION_INDEX({range: [val[0],val[1]], uiid:this.uiid})                        
      },
      checkRange(range) {
        if(range) {
          const idxMin = range[0]
          const idxMax = range[1]
          this.currentValue = [idxMin != -1?idxMin:0, idxMax!= -1?idxMax:this.dates.length-1];
        }
        else this.currentValue = [0,this.dates.length-1]            
      },
      endMove(range) {
        if(!this.updateOnMove) this.changeValue(range)
      },
      onMove(range){
        if(this.updateOnMove) this.changeValue(range)
      }  
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

/*.mdc-slider__pin{
  display: none!important;
}*/

</style>

<style scope>

</style>